
import { writable } from 'svelte/store'

import { type OpenaiThreadItem } from './types'



const store = writable<OpenaiThreadItem>({} as OpenaiThreadItem)

export { store as openai_thread_item_store }

